export const environment = {
    local: true,
    production: false,
    hmr: false,
    banner: `Apollo DEV`,
    version: '2026.0619.0842',

    ApolloUrl: 'https://devapollo2.siriusfinance.cz',
    ApolloApiUrl: 'https://devapolloapi2.siriusfinance.cz/api',
    BaseUrl: 'https://devbase.siriusfinance.cz',
    BaseApiUrl: 'https://devbaseapi.siriusfinance.cz/api',
    IsvrApiUrl: 'https://devisvrapi.siriusfinance.cz/api',
    ClientPortalUrl: 'https://devportal.siriusfinance.cz',
    ClientPortalSignUrl: 'https://devportal.siriusfinance.cz/podepsani-dokumentu',
    PortalUrl: 'https://devsso.siriusfinance.cz',
    HypoportalClientUrl: 'https://sirius.redesign.hyposrovnani.cz/DataLoad?clientId=',

    SsoUrl: 'https://devsso.siriusfinance.cz',
    SsoAllowedUrls: ['https://devsso.siriusfinance.cz/', 'https://devbaseapi.siriusfinance.cz/', 'https://devapolloapi2.siriusfinance.cz/', 'https://devisvrapi.siriusfinance.cz/', 'http://localhost:5000/', 'http://localhost:5001/'],
    SsoClientId: 'app-test-apollo',
    SsoDummyClientSecret: 'MxtfH4E4ZhvfXkNBNoKxVWeExL2HyEEHdZnd7fYe4Cgf',
    SsoScope: 'openid profile roles advisor api_apollo api_base api_isvr_search offline_access',
};
